import React, { useEffect } from "react"; // ✅ FIXED
import { Routes, Route } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


import Services from './components/Servicepage/Services';
import AboutUsPage from "./components/pages/AboutUsPage"; 
import HeroSection from "./components/HeroSection";
import EventCategories from "./components/EventCategories";
import CommitmentSection from "./components/CommitmentSection";
import FeaturesSection from "./components/FeaturesSection";
import CoreValuesSection from "./components/CoreValuesSection";
import EventServicesSection from "./components/EventServicesSection";
import TestimonialSection from "./components/TestimonialSection";
import WhyChooseUs from "./components/WhyChooseUs";
import Footer from "./components/Footer";
import BlogSection from "./components/BlogSection";
import EventHeroSection from "./components/EventHeroSection";
import EventFaqSection from "./components/EventFaqSection";
import ShowcaseSection from "./components/ShowcaseSection";
import EventCTASection from "./components/EventCTASection";
import ContactUs from "./components/ContactPage/ContactUs";
import Gallery from "./components/gallerypage/gallery";
import Video from "./components/Videopage/Video";
import BackToTopButton from "./components/BackToTopButton";


// Individual service detail components
import CorporateParties from './components/Service-inner-pages/ServiceDetails';
import MarketingEventsDetails from "./components/Service-inner-2/Marketing-Events";
import SocialEventsDetails from "./components/Service-inner-3/SocialEventsDetails";
import EntertainmentEventsDetails from "./components/Service-inner-4/EntertainmentEventsDetails";
import EventProductionDetails from "./components/Service-inner-5/EventProductionDetails";
import OfflineMarketingDetails from "./components/Service-inner-6/OfflineMarketingDetails";
import HangerDetails from "./components/Service-inner-7/HangerDetails";
import VideoNav from "./components/Video/videonav";
import WeddingManagementDetails from "./components/Service-inner-8/wed-magagement";
function Home() {
  return (
    <>
      <HeroSection />
      <EventCategories />
      <CommitmentSection />
      <FeaturesSection />
      <CoreValuesSection />
      <EventServicesSection />
      <TestimonialSection />
      <WhyChooseUs />
      <EventCTASection />
      <ShowcaseSection />
      <EventFaqSection />
      <EventHeroSection />
      <BlogSection />
      <Footer />
    </>
  );
}

function App() {
  // Disable right-click on all images
  useEffect(() => {
    const disableContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', disableContextMenu);
    return () => {
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} /> 
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/video" element={<Video />} />
        <Route path="/videonav" element={<VideoNav />} />

        {/* Individual Service Routes */}
        <Route path="/services/corporate-parties" element={<CorporateParties />} />
        <Route path="/services/marketing-events" element={<MarketingEventsDetails />} />
        <Route path="/services/SocialEventsDetails" element={<SocialEventsDetails />} />
        <Route path="/services/EntertainmentEventsDetails" element={<EntertainmentEventsDetails />} />
        <Route path="/services/EventProductionDetails" element={<EventProductionDetails />} />
        <Route path="/services/OfflineMarketingDetails" element={<OfflineMarketingDetails />} />
        <Route path="/services/HangerDetails" element={<HangerDetails />} />
        <Route path="/services/WeddingManagementDetails" element={<WeddingManagementDetails />} /> 
      </Routes>

      <BackToTopButton />
    </>
  );
}

export default App;
